import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import moment from "moment";
import { AJUSTAR_FERIAS_TIPO_ALTERACAO } from "../../../constants";
import { AgendarFeriasService } from "../../../services/AgendarFeriasService.js";
import { FeriasService } from "../../../services/FeriasService";
import { SolicitarFeriasService } from "../../../services/SolicitarFeriasService";
import ProrrogarInterromperFerias from "../agendar-ferias/prorrogar-interromper-ferias/ProrrogarInterromperFerias.vue";

export default {
  name: "AgendarFerias",

  props: {
    options: {
      type: Array,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField,
    ProrrogarInterromperFerias
  },

  beforeMount() {
    this.initializeForm();
  },

  mounted() {
    this.id = this.selected;
    this.options.tipoAlteracao = AJUSTAR_FERIAS_TIPO_ALTERACAO;
    if(this.$store.state.user.Civil){
      this.titulo = `Agendar Férias de Civis`;
    }
  },

  data: () => ({
    id: null,
    actionsDialogt: false,
    interromperDialog: false,
    unidadeLotacao:null,
    titulo: "Agendar Férias",
    exercicio:null,
    militar: null,
    parcela: null,
    form: {},
    formInterromper:{},
    loading: {
      field: false,
      btn: false,
    }
  }),


  disabled: false,

  watch: {
    unidadeLotacao: async function(unidade_id){
      if(unidade_id == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      } 
      await this.pegarPessoasPorUnidadeSemFerias(unidade_id);
      this.$forceUpdate()
    },
    militar: async function(pessoa_id){
      if(pessoa_id == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      } 
      this.pegarGraduacaoPorPessoa(pessoa_id);
      await this.pegarExercicioPorPessoa(pessoa_id);
      this.$forceUpdate()
    },
    exercicio: async function(exercicio){
      if(exercicio == ""){
        SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        return;
      } 
      this.pegarDiasPendentesDaPessoa(exercicio,this.militar);
      this.pegarParcelasDaPessoa(exercicio, this.militar);
      this.$forceUpdate()
    }
  },

  methods: {
    async calculateDays() {
      if (this.form.dataInicio != null) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasSolicitados);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFim = response.dataFim;
        this.form.numeroDiasSolicitados = response.dias_uteis;
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    async calculateDaysDoacaoSangue() {
      if(this.form.numeroDiasDoacao > 2) {
        return SnackBarModule("O período de doação de sangue nao pode ser superior a dois dias", "error");
      }
      if (this.form.dataInicioSangue != null) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicioSangue).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasDoacao);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFimSangue = response.dataFim;
        this.form.numeroDiasDoacao = response.dias_uteis;
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    initializeForm() {
      this.options.postoGraduacao = [],
      this.form = {
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        numeroDiasSolicitados: null,


        dataInicioSangue: null,
        dataFimSangue: null,
        numeroDiasDoacao: null,

        idTipo: 1,

      }

    },

    async pegarPessoasPorUnidadeSemFerias(unidade_id){
      const response = await AgendarFeriasService.pegarPessoasPorUnidadeSemFerias(unidade_id);
      this.options.militares =  response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });


      this.options.militares?.unshift({ text: "Selecione", value: "" })

      return this.options.militares;
    },
    async pegarGraduacaoPorPessoa(pessoa_id){
      const response = await AgendarFeriasService.pegarGraduacaoPorPessoa(pessoa_id);
      this.options.postoGraduacao = response[0].graduacao
      return;
    },
    async pegarDiasPendentesDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasService.pegarDiasPendentesDaPessoa(exercicio,pessoa_id);
      this.form.numeroDias = response

      return;
    },

    async pegarParcelasDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasService.pegarParcelasDaPessoa(exercicio,pessoa_id);
      this.formInterromper.dataInicio = response.data_ini;
      this.formInterromper.dataFim = response.data_fin;

      return;
    },

    async pegarExercicioPorPessoa(pessoa_id){
      const response = await FeriasService.getExercicioPorMilitar(pessoa_id);
      this.options.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.options.exercicio?.unshift({ text: "Selecione", value: "" })

    },

    prepareFormAgendar() {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
        formData.append("data_fin", moment(this.form.dataFim).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasSolicitados);

        this.form.dataInicioSangue ?  formData.append("data_ini_d_sangue", moment(this.form.dataInicioSangue).format("YYYY-MM-DD")) : null;
        this.form.dataFimSangue ? formData.append("data_fin_d_sangue", moment(this.form.dataFimSangue).format("YYYY-MM-DD")) : null;
        this.form.numeroDiasDoacao ? formData.append("dias_doacao", this.form.numeroDiasDoacao): null;


        formData.append("id_sigrh", this.militar);
        formData.append("id_tipo", this.form.idTipo);

        formData.append("exercicio", this.exercicio);

        this.saveFormAgendar(formData);
        return;
      //SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },



    async saveFormAgendar(formData) {
      this.loading.btn = true;
      const response = await AgendarFeriasService.agendarFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.$refs.form.reset();
      this.$emit("on-close");
    },

    cleanFilter(){
      this.initializeForm();
      this.options.militares = [];
      this.options.postoGraduacao = [];
      this.form.formInterromper = "";
      this.actionsDialog = false;
    },

    closeActionsDialog() {
      this.cleanFilter();
      this.getFerias();
    }
  },
};